import { PureComponent, PropsWithChildren } from "react";

export default class ExtrasFilterAdvancedFilterOption extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-extras-filter__adv-filter-option">
        {this.props.children}
      </div>
    );
  }
}
